import { CommitmentEvent } from './commitmentEvent';
import { CommitmentEventCategory } from './commitmentEventCategory';
import { MemberCommitment } from './memberCommitment';
import { MemberCommitmentReport } from './memberCommitmentReport';

export const cci = { ...CommitmentEvent, ...CommitmentEventCategory, ...MemberCommitment, ...MemberCommitmentReport };
